import { lazy } from "react";

const HomePage = lazy(() => import("views/home"));
const ArticlePage = lazy(() => import("views/articles"));

const NotFoundPage = lazy(() => import("views/NotFound"));

export const routes = [
  {
    element: <HomePage />,
    exact: true,
    path: "/",
  },
  {
    element: <ArticlePage />,
    exact: true,
    path: "/article/:articleId",
  },
  {
    element: <NotFoundPage />,
    path: "*",
  },
];
